/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { N200 } from '@atlaskit/theme/colors';
import { fontFamily as getFontFamily } from '@atlaskit/theme/constants';
import { h200 } from '@atlaskit/theme/typography';
const fontFamily = getFontFamily();
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const fieldsetLabelStyles = css([h200({
  theme: {
    mode: 'light'
  }
}), {
  display: 'inline-block',
  marginTop: 0,
  marginBottom: "var(--ds-space-050, 4px)",
  color: `var(--ds-text-subtle, ${N200})`,
  fontFamily: fontFamily
}]);

/**
 * __Label__
 *
 * A label represents a caption for an item in a user interface.
 *
 * It's recommended that a label has a `4px` spacing above its associated
 * control element.
 */
export const Label = ({
  children,
  htmlFor,
  id,
  testId
}) => jsx("label", {
  css: fieldsetLabelStyles,
  id: id,
  htmlFor: htmlFor,
  "data-testid": testId
}, children);

/**
 * __Legend__
 *
 * A Legend represents a caption for a fieldset in a user interface.
 */
export const Legend = ({
  children
}) => {
  return jsx("legend", {
    css: fieldsetLabelStyles
  }, children);
};
export default Label;